import { 
  Vacancy, 
  VacancyFormData
} from '../types/vacancy';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const vacanciesApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getVacancies: build.query<any, void>({
      query: () => ({
        url: appEndpoint.getVacancies,
        method: 'get',
      }),
      providesTags: ['Vacancies'],
    }),
    
    getVacancyById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.getVacancies}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'Vacancies', id }],
    }),

    addVacancy: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.addVacancy,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Vacancies"] : []),
    }),

    updateVacancy: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.updateVacancy}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Vacancies"] : []),
    }),

    deleteVacancy: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.deleteVacancy}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Vacancies'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetVacanciesQuery,
  useGetVacancyByIdQuery,
  useAddVacancyMutation,
  useUpdateVacancyMutation,
  useDeleteVacancyMutation,
} = vacanciesApi;

